import { styled, Card, Box, Stack, Typography } from '@mui/material'
import { Button } from '@center/ui-kit'

export const DatePickerCard = styled(Card)(({ theme, showpresets }) => ({
  display: 'flex',
  flexDirection: 'column',
  maxWidth: showpresets ? 600 : 400,
  marginTop: 0.5,
  height: 'auto',
  maxHeight: '90vh',
  borderRadius: '16px',
  border: '1px solid #DAE0E7',
  boxShadow: `0px 1.85px 3.15px 0px #00000014,
            0px 8.15px 6.52px 0px #0000000A,
            0px 20px 13px 0px #0000000A,
            0px 38.52px 25.48px 0px #0000000B,
            0px 64.81px 46.85px 0px #0000000E`,
  [theme.breakpoints.down('sm')]: {
    maxWidth: 'calc(100vw - 16px)'
  }
}))

export const FlexBox = styled(Box)({
  display: 'flex',
  flex: 1,
  overflow: 'auto'
})

export const ContentStack = styled(Stack)({
  flex: 1,
  position: 'relative'
})

export const HeaderTypography = styled(Typography)(({ theme }) =>({
  padding: 16,
  backgroundColor: theme.palette.surface.secondary,
  height: '50px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '12px',
  color: theme.palette.text.body.primary,
  position: 'sticky',
  top: 0,
  zIndex: 1
}))

export const CalendarStack = styled(Stack)(({ theme }) => ({
  padding: 24,
  gap: 16,
  marginBottom: '60px',
  [theme.breakpoints.down('sm')]: {
    padding: 12
  }
}))

export const ButtonsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '8px 24px',
  width: '100%',
  position: 'absolute',
  bottom: 0,
  left: 0,
  backgroundColor: theme.palette.background.paper,
  borderTop: `1px solid ${theme.palette.border.primary}`,
  borderBottomLeftRadius: '16px',
  borderBottomRightRadius: '16px',
  [theme.breakpoints.down('sm')]: {
    padding: '8px 12px'
  }
}))

export const ButtonsBox = styled(Box)(({ showreset }) => ({
  display: 'flex',
  gap: 16,
  marginLeft: !showreset ? 'auto' : undefined
}))

export const StyledButton = styled(Button)({
  minHeight: '32px',
  fontSize: '12px'
})
